var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.54e0a5cd0de227eee3b34c401b88a67d.svg#p';
                    var viewUrl = 'sprites.54e0a5cd0de227eee3b34c401b88a67d.svg#view-p';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };